import React, { useState, useEffect } from "react";
import {
    Row, Col,
    Button, FormGroup, Input, Label,
    Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import DatePicker from "react-datepicker";
import ApiCaller from "../../../../api/apiCaller";

interface SelectionElementItemProps {
    isShow?: boolean;
    onItemSaved?: Function;
    onSelectionModalClose?: Function;
    contentType?: string;
    contentId?: number;
}

const ScanningPeriodModal = ({
    isShow, onItemSaved, onSelectionModalClose, contentType, contentId
}: SelectionElementItemProps) => {
    const [showSelectionModal, setShowSelectionModal] = useState<boolean | undefined>(isShow);
    const [currentLocation, setCurrentLocation] = useState<any | null>({});
    const [scanningDevices, setScanningDevices] = useState<Array<any>>([]);
    const [scanningPeriodData, setScanningPeriodData] = useState<any | null>({
        measure_for_content_type: contentType,
        measure_for_content_id: contentId,
        from_date: new Date(),
    });

    const getCurrentPosition = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setCurrentLocation({
                    latitude: position.coords.latitude, 
                    longitude: position.coords.longitude
                });
            },
            err => alert('Error code ' + err.code + ': ' + err.message),
        );
    }

    const updateAttr = (attributeName:string, value:any) => {
        const objectToAdd:any = {};
        objectToAdd[attributeName] = value;
        setScanningPeriodData({
            ...scanningPeriodData,
            ...objectToAdd,
        });
    }

    const toogleSelectionModal = () => {
        setShowSelectionModal(!showSelectionModal);
        if (onSelectionModalClose && !showSelectionModal) {
            onSelectionModalClose(false);
        }
    }

    const submitData = async () => {
        const dataToSubmit = {
            ...scanningPeriodData,
            ...currentLocation,
        };
        const res = await ApiCaller.post(
            'traffic_scan_period/',
            {
                ...scanningPeriodData,
                ...currentLocation,
            }
        );
        if (res.result) {
            setShowSelectionModal(false);
            if (onItemSaved) {
                onItemSaved(dataToSubmit);
            }
        }
    }

    const getDevices = async () => {
        const res = await ApiCaller.get('traffic_scan_device/');
        if (res.result) {
            setScanningDevices(res.result);
        }
    }

    useEffect(() => {
        getCurrentPosition();
        getDevices();
    }, []);

    const CustomTimeInput = ({ value, onChange }:any) => (
        <Input
          value={value}
          onChange={e => onChange(e.target.value)}
          style={{ border: "solid 1px pink" }}
        />
    );
    return (
        <Modal isOpen={showSelectionModal} toggle={toogleSelectionModal}>
            <ModalHeader toggle={toogleSelectionModal}>Quét traffic</ModalHeader>
            <ModalBody>
                <Row>
                    <Col xs={12}>
                        {currentLocation &&
                            <p>Vị trí: {currentLocation?.latitude} - {currentLocation?.longitude}</p>
                        }
                        <FormGroup>
                            <Label>Mã máy</Label>
                            <Input
                                type="select"
                                onChange={(e) => updateAttr('device', { id: e.target.value })}
                            >
                                <option>--- Chọn thiết bị đo ---</option>
                                {scanningDevices.map(scanningDevice =>
                                    <option
                                        key={scanningDevice.id}
                                        value={scanningDevice.id}
                                    >
                                        {scanningDevice.unique_device_code}
                                    </option>
                                )}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>Tên lượt đo *</Label>
                            <Input
                                type="text"
                                onChange={(e) => updateAttr('name', e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>Mô tả</Label>
                            <Input
                                type="textarea"
                                rows={2}
                                onChange={(e) => updateAttr('description', e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>Thời gian bắt đầu đo</Label>
                            <DatePicker
                                dateFormat="yyyy-MM-dd HH:mm:ss"
                                selected={scanningPeriodData.from_date}
                                onChange={(date:any) => updateAttr('from_date', date)}
                                showTimeInput
                                customTimeInput={<CustomTimeInput />}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toogleSelectionModal}>Hủy</Button>
                <Button color="primary" onClick={submitData}>Lưu</Button>
            </ModalFooter>
        </Modal>
    );
}

const styles = {}

export default ScanningPeriodModal;